function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5c-.178 0-.356.143-.491.43L8.743 8.811l-6.183.942c-.604.092-.74.532-.306.979l4.476 4.58-1.056 6.464c-.074.456.093.724.396.724.115 0 .25-.038.398-.12L12 19.328l5.532 3.052c.149.082.283.12.398.12.303 0 .47-.268.396-.724l-1.057-6.465 4.477-4.58c.435-.446.297-.886-.305-.978l-6.185-.942-2.766-5.88c-.135-.288-.312-.431-.49-.431",
    fill: "#212121",
    fillRule: "evenodd"
  }));
}

export var ReactComponent = SvgComponent;
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-fav-star.svg";